<ion-header>
    <ion-toolbar>

        <ion-title mode="ios" role="heading">{{ 'HOW_TO_HEADER' | translate}}</ion-title>

        <ion-buttons slot="end">
            <ion-button
                class="icon-button-accessible-background-contrast"
                [attr.aria-label]="'ARIA_LABEL_CLOSE' | translate"
                (click)="dismiss()">
                <ion-icon slot="icon-only" name="close"></ion-icon>
            </ion-button>
        </ion-buttons>

    </ion-toolbar>
</ion-header>

<ion-content>
    <br /><br />
    <ion-list role="list" class="list-compact">
        <ion-item button role="listitem" (click)="presentModal('howToText', 'LOCATION_SERVICES')">
            <!-- <ion-icon name="ios-navigate" item-start></ion-icon> -->
            <p>{{ 'HOW_TO_ENABLE_LOCATION_SERVICES' | translate }}</p>
            <ion-icon name="chevron-forward-outline" aria-hidden="true" slot="end"></ion-icon>
        </ion-item>
        <!-- <button ion-item *ngIf="!isLongDistance" (click)="presentModal('HowToDetailPage', 'ADD_STOP')">
            {{ 'HOW_TO_ADD_STOP' | translate }}
            <ion-icon name="ios-arrow-forward" item-end></ion-icon>
        </button>
        <button ion-item *ngIf="!isLongDistance" (click)="presentModal('HowToDetailPage', 'ADD_TRIP')">
            {{ 'HOW_TO_ADD_TRIP' | translate }}
            <ion-icon name="ios-arrow-forward" item-end></ion-icon>
        </button>
        <button ion-item *ngIf="!isLongDistance" (click)="presentModal('HowToDetailPage', 'PROXY')">
            {{ 'HOW_TO_PROXY' | translate }}
            <ion-icon name="ios-arrow-forward" item-end></ion-icon>
        </button> -->
    </ion-list>
</ion-content>